import { Injectable } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { AppConfig } from 'src/app/App-Config';
import { LocalizationService } from 'src/app/ngage-apps/lots/services/localization-service/localization.service';
import { BorderService } from 'src/app/ngage-core/services/borders/borders.service';

@Injectable({
  providedIn: 'root'
})
export class UserInterfaceService {
  constructor(private alertbox: AlertController, private dataservice: BorderService, private loadingController:LoadingController,
    private ls: LocalizationService) { }
  directToHometab=false;
  registered=false;
  enrolled=false;
  enrollbutton = true;
  showTabbtn=true;
  userStatus=0;
  showFooterShadow=true;
  public thiscourse: any;
  public notificationCount = 0;
  showSplash=true;
  static count_updator;
  public note_updator;
  loading:HTMLIonLoadingElement;
  defaultloading: HTMLIonLoadingElement;
  loadingModal: any;
  isLoaderCreated:boolean=false;
  
  async displayDefaultLoader() {
    this.defaultloading = await this.loadingController.create({
      spinner: "lines",
      message: this.ls.getTranslationByKey(this.ls.KEYS.STUDENT.loading_common, this.ls.PAGES.STUDENT.common),
      cssClass: 'socioLogin'
    });
    await this.defaultloading.present()
  }

  hideDefaultLoader() {
    console.log("dismissing loader")
    if(this.defaultloading) this.defaultloading.dismiss();
  }

  resetUIService(){
    this.directToHometab=false;
    this.registered=false;
    this.enrolled=false;
    this.userStatus=0;
    this.notificationCount = 0;
    this.showFooterShadow=true;
    this.enrollbutton = true;
    this.showTabbtn=true;
  }
  
  updateNotificationCount() {
    var uid = localStorage.getItem('uuid')
    if (uid) {
      let url = AppConfig.userServiceUrl + '/orgs/user_notification/by_user_id/' + uid + '/count';
      if (UserInterfaceService.count_updator) {
        UserInterfaceService.count_updator.unsubscribe();
      }
      UserInterfaceService.count_updator = this.dataservice.get(url).subscribe((res: any) => {
        this.notificationCount = res.count;
      })
    } else {
      if (UserInterfaceService.count_updator) UserInterfaceService.count_updator.unsubscribe();
    }
  }

  async presentAlert(header,message,btns,css,subtitle) {
    const alert = await this.alertbox.create({
      cssClass: css,
      header: header,
      subHeader: subtitle,
      message: message,
      buttons: btns
    });

    await alert.present();
  }
}
